import React from "react";

interface Props {
    size?: number;
    color?: string;
}

export const RiskIcon = (props: Props) => {
    const size = props.size ?? 20;
    const color = props.color ?? "var(--color-purple-400)";

    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.5 2L4 4.71003V9.47492C4 12.9859 6.925 15.9953 10.5 17.5C14.075 15.9953 17 12.9859 17 9.47492V4.71003L10.5 2Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.78809 10.093L9.78809 5.88813C9.78809 5.39763 10.1239 5 10.5381 5C10.9523 5 11.2881 5.39763 11.2881 5.88813V10.093C11.2881 10.5835 10.9523 10.9811 10.5381 10.9811C10.1239 10.9811 9.78809 10.5835 9.78809 10.093Z"
                fill={color}
            />
            <path
                d="M10.6412 13.9929C11.1383 13.9929 11.5412 13.5899 11.5412 13.0929C11.5412 12.5958 11.1383 12.1929 10.6412 12.1929C10.1442 12.1929 9.74121 12.5958 9.74121 13.0929C9.74121 13.5899 10.1442 13.9929 10.6412 13.9929Z"
                fill={color}
            />
        </svg>
    );
};
